<script>
import { DynamicElementMixin } from "%/dynamic-components/render-engine/mixins/production/dynamic-element-mixin";
import BrandedTextStyleOptions from "%/dynamic-components/render-engine/bundles/branded-text-style-options";
import TextElement
  from "%/dynamic-components/render-engine/components/production/elements/text-element/TextElement.vue";
import DynamicElementWithContext from "%/dynamic-components/render-engine/mixins/production/dynamic-element-with-context-mixin";
import LinkToEntityPage from "%/dynamic-components/render-engine/options/link-to-entity-page";
import NumberFormat from "%/dynamic-components/render-engine/options/number-format";
import Prefix from "%/dynamic-components/render-engine/options/action-options/prefix";
import Suffix from "%/dynamic-components/render-engine/options/action-options/suffix";
import { formatFieldText } from "%/dynamic-components/render-engine/helpers/number-format";
import { resolveEntityPageUrl }
  from "@bloglovin/inspire-engine/DynamicComponents/Helpers/entity-page-links";

export default {
  name: "DynamicAppTextElement",
  extends: TextElement,
  mixins: [DynamicElementMixin, DynamicElementWithContext],
  elementPanelSettings: {
    displayName: "Text",
    elementGroup: "general",
    displayIcon: "text",
    elementType: "element",
  },
  hidden: true,
  optionBundles: [
    new BrandedTextStyleOptions({}, {
      "text-option": true,
    }),
  ],
  options: [
    LinkToEntityPage,
    Prefix,
    Suffix,
    NumberFormat,
  ],
  computed: {
    isEditable() {
      return false;
    },
    value() {
      return formatFieldText(this.valueFromContext, {
        format: this.getOptionValue(NumberFormat),
        prefix: this.getOptionValue(Prefix),
        suffix: this.getOptionValue(Suffix),
      });
    },
    // "Link To Page": resolve the bound entity's display page through the
    // host-registered resolver; the text-element-mixin click machinery
    // prefers this href, so a linked Story/Event title navigates like an
    // authored goToUrl click action. A null resolution renders unlinked.
    entityPageHref() {
      if (this.editMode || this.getOptionValue(LinkToEntityPage) !== true) {
        return null;
      }
      return resolveEntityPageUrl(
        this.entityType,
        this.contextItem.entityPkUrlVars,
        this.appName,
      );
    },
  },
};
</script>
